export enum ActivitiesEnum {
    NextDays = 'proximos-dias',
    Past = 'vencidas',
    Today = 'hoje',
    Tomorrow = 'amanha'
}
